/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Dispatch, type SetStateAction, useEffect, useState } from "react";
import ModalGeneric from "../../../../components/ModalGeneric/ModalGeneric";
import { useQuery } from "@tanstack/react-query";
import {
  loadAllCategoryProduct,
  loadTypeProduct,
  loadUnidadeMedida,
} from "../../../../services/products";

import input from "../../../../assets/styles/components/input.module.css";
import Button from "../../../../components/Button/Button";
import styles from "./ModalFilter.module.css";

type props = {
  setIsHidden: Dispatch<
    SetStateAction<{
      addProduct: boolean;
      addCategory: boolean;
      filter?: boolean;
    }>
  >;
  setFilterValues: Dispatch<
    SetStateAction<{
      unitMeasure?: string;
      typeProduct?: string;
      category?: string;
    }>
  >;
  filterValues: {
    unitMeasure?: string;
    typeProduct?: string;
    category?: string;
  };
};

const ModalFilter = ({ setIsHidden, setFilterValues, filterValues }: props) => {
  const [value, setValue] = useState<{
    unitMeasure: string;
    typeProduct: string;
    category: string;
  }>({
    unitMeasure: filterValues.unitMeasure || "",
    typeProduct: filterValues.typeProduct || "",
    category: filterValues.category || "",
  });

  const { data: unidadeMedida } = useQuery({
    queryKey: ["loadUnidadeMedida"],
    queryFn: async () => await loadUnidadeMedida(),
  });

  const { data: loadTypeProducts } = useQuery({
    queryKey: ["loadTypeProduct"],
    queryFn: async () => await loadTypeProduct(),
  });

  const { data: categoryProduct } = useQuery({
    queryKey: ["loadAllCategoryProduct"],
    queryFn: async () => await loadAllCategoryProduct(),
  });

  const renderSelect = (
    data: any[],
    label: string,
    Key: string,
    field: string
  ) => {
    return (
      <div>
        <p>{label}</p>
        <select
          name=""
          id=""
          className={input.input}
          value={value[field as keyof typeof value]}
          onChange={(e) =>
            setValue((prev) => ({ ...prev, [field]: e.target.value }))
          }>
          <option value="">Selecione</option>
          {data?.map((item) => (
            <option key={item[Key]} value={item[Key]}>
              {item.titulo}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const handleFilter = () => {
    setFilterValues(value);
    handlecloseModal();
  };

  const handlecloseModal = () => {
    setIsHidden((prev) => ({ ...prev, filter: true }));
  };

  useEffect(() => {
    const handleEnter = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        handleFilter();
      }
    };

    document.addEventListener("keydown", handleEnter);

    return () => document.removeEventListener("keydown", handleEnter);
  });

  return (
    <ModalGeneric
      containerClass={styles.container}
      contentClass={styles.containerModalFilter}
      title="Filtro"
      onClick={handlecloseModal}>
      <div className={styles.containerFilter}>
        <div>
          {unidadeMedida &&
            renderSelect(
              unidadeMedida?.loadUnidadeMedida,
              "Tipo de medida",
              "uid_tipo_unidade_medida",
              "unitMeasure"
            )}
        </div>
        <div>
          {loadTypeProducts &&
            renderSelect(
              loadTypeProducts?.loadTypeProducts,
              "Tipo do produto",
              "uid_tipo_produto",
              "typeProduct"
            )}
        </div>
        <div>
          {categoryProduct &&
            renderSelect(
              categoryProduct,
              "Categoria",
              "uid_produto_categoria",
              "category"
            )}
        </div>
        <Button variant="contain" onClick={handleFilter}>
          Filtrar
        </Button>
      </div>
    </ModalGeneric>
  );
};

export default ModalFilter;
